<ng-container *transloco="let t">
  <rma-icon class="text-caution-50" size="small" glyph="star" [fill]="1" aria-hidden="true" />
  &nbsp;
  <span class="font-bold text-steel-100"> {{ rating }}</span>
  &nbsp;

  @if (count) {
    <rma-anchor-or-div class="inline" [routerLink]="showLinksToIndividualProfile ? reviewsRoute : undefined" [relativeTo]="relativeTo">
      ({{ count }} {{ t('review', { reviewsCount: count }) }})
    </rma-anchor-or-div>
  }
</ng-container>
